import React, { ReactElement } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

interface RTESamplesProps {
  sampleSelectedCallback?: (premise: string, hypothesis: string) => void;
}

const Samples = (props: RTESamplesProps): ReactElement => {
  const { sampleSelectedCallback } = props;

  const getLabelText = (label: string): string => {
    return label === "LABEL_1" ? "Entails" : "Does not entail";
  };

  const SAMPLES: { premise: string; hypothesis: string; label: string }[] = [
    { premise: "A empresa anunciou que vai lançar um novo modelo de smartphone na próxima semana.", hypothesis: "A companhia vai apresentar um novo telemóvel em breve.", label: "LABEL_1" },
    { premise: "O trânsito na ponte ficou congestionado devido ao acidente matinal.", hypothesis: "Houve um acidente de manhã na ponte.", label: "LABEL_1" },
    { premise: "O atleta terminou a maratona em duas horas e dez minutos.", hypothesis: "O atleta demorou quase três horas para completar a prova.", label: "LABEL_0" },
    { premise: "As previsões meteorológicas indicam chuva forte para amanhã.", hypothesis: "Amanhã o tempo estará seco e sem chuva.", label: "LABEL_0" },
    { premise: "O projeto de lei foi aprovado pelo parlamento e entrará em vigor em breve.", hypothesis: "A nova legislação foi aprovada.", label: "LABEL_1" },
  ];

  return (
    <>
      {SAMPLES.map((sample, index) => {
        return (
          <Paper
            key={"sample-" + index}
            variant="elevation"
            elevation={4}
            sx={{
              padding: "8px",
              marginBottom: "10px",
              border: "1px solid",
              borderColor: "primary.light",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => {
              sampleSelectedCallback &&
                sampleSelectedCallback(sample.premise, sample.hypothesis);
            }}
          >
            <Stack spacing={1.5}>
              <Chip
                label={sample.label + " · " + getLabelText(sample.label)}
                color={sample.label === "LABEL_1" ? "success" : "default"}
                variant={sample.label === "LABEL_1" ? "filled" : "outlined"}
                size="small"
                sx={{ alignSelf: "flex-start", fontWeight: 700 }}
              />
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Premise
                </Typography>
                <Typography variant="body2">{sample.premise}</Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Hypothesis
                </Typography>
                <Typography variant="body2">{sample.hypothesis}</Typography>
              </Box>
            </Stack>
          </Paper>
        );
      })}
    </>
  );
};

export default Samples;
